import { useState } from 'react'
import { Monitor, Moon, Sun } from 'lucide-react'
import { Button } from '~/components/ui/button'
import { applyTheme, getStoredTheme, type Theme } from '~/lib/theme'

// 시스템 → 라이트 → 다크 순환. 기본은 시스템(OS 설정을 따름).
const ORDER: Theme[] = ['system', 'light', 'dark']
const ICON = { system: Monitor, light: Sun, dark: Moon }
const LABEL: Record<Theme, string> = {
    system: '시스템',
    light: '라이트',
    dark: '다크',
}

/** 테마 토글(시스템/라이트/다크 3단). document.documentElement 의 dark 클래스를 제어한다. */
export function ThemeToggle() {
    const [theme, setTheme] = useState<Theme>(() => getStoredTheme())

    const cycle = () => {
        const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length]
        applyTheme(next)
        setTheme(next)
    }

    const Icon = ICON[theme]
    const label = `테마: ${LABEL[theme]} (클릭하여 전환)`
    return (
        <Button
            variant='outline'
            size='icon-sm'
            onClick={cycle}
            aria-label={label}
            title={label}>
            <Icon />
        </Button>
    )
}
